import { Outlet } from "react-router-dom";

import Footer from "./Footer";
import Header from "./Header";
import PatientLayout from "./PatientLayout";

export default function PlainAppShell() {
  return (
    <div className="min-h-screen bg-bg text-text flex flex-col">
      <Header />
      <main className="flex-1 w-full px-4 md:px-6 lg:px-8 py-6">
      {/* <PatientLayout> */}
        <Outlet />
      {/* </PatientLayout> */}
      </main>
      <Footer />
    </div>
  );
}
